/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 添加或者更新我的收货地址
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  addrReq: member.AddrReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/address`,
    data: addrReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
